const formatCnpj = (cnpj: string): string => {
  cnpj = cnpj.toUpperCase().replace(/[^A-Z0-9]+/g, '');
  cnpj = `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(
    5,
    8
  )}/${cnpj.substring(8, 12)}-${cnpj.substring(12, 14)}`;
  return cnpj;
};
export default formatCnpj;
